import React from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import SectionHeader from '../../../ui/SectionHeader';
import ChannelPreviewList from '../../../ui/ChannelPreviewList';
import { baseUrls } from '../../../../utils/baseUrls.utils';
import { useHistory } from 'react-router-dom';
import { useTheme, Button } from 'neon-design-system';
import { Channel } from '../../../../shared/types';
import SkeletonCardGrid from '../../../ui/Skeletons/SkeletonCardGrid';

interface ChannelsSectionProps {
	title: string;
	channels: Channel[];
	loading: boolean;
	type?: 'premium' | 'free';
}

export const ChannelsSection = (props: ChannelsSectionProps) => {
	const { title, channels, loading, type } = props;
	const history = useHistory();
	const { theme } = useTheme();
	const xsDown = useMediaQuery(theme.breakpoints.down('xs'));

	const onBrowseButtonClick = () => {
		if (type) {
			history.push(baseUrls.channels.main + `?${type}`);
			return;
		}

		return history.push(baseUrls.channels.main)
	}

	return (
		<>
			{loading || (!loading && channels?.length > 0) ?
				(
					<Grid container spacing={2} style={{ justifyContent: 'space-between', marginBottom: 8 }}>
						<Grid item xs={12} sm={6}>
							<SectionHeader title={title} sectionHeaderOffsetDisabled />
						</Grid>
						<Grid item xs={12} sm={6} style={{ textAlign: xsDown ? 'left' : 'right' }}>
							<Button colorType="primary" size="medium" onClick={onBrowseButtonClick}>
								Browse {type || ' '} channels
							</Button>
						</Grid>
					</Grid>
				) : <></>
			}
			{!loading ?
				<ChannelPreviewList
					channels={channels}
					loading={loading}
				/> :
				<SkeletonCardGrid
					generatedItemsLength={3}
					containerProps={{
						spacing: 2
					}}
					itemProps={{
						xs: 12,
						sm: 6,
						md: 4
					}}
				/>
			}
		</>
	)}
